<ul *ngIf="isEnabled" class="h-product-nav tab-nav navbar-nav global-search-placeholder">
    <li class="tab-nav-item nav-item" (click)="showsearch()">
        <span *ngIf="canDisplayIcon" [ngClass]="desktopClass"></span>
    </li>
</ul>
